import { z } from "zod";

export const countrySchema = z.object({
  id: z.number().int().positive(),
  name: z.string(),
  code: z.string().length(2),
  dialCode: z.string().regex(/^\+\d+$/),
  flagUrl: z.string().url().nullable(),
});
export type Country = z.infer<typeof countrySchema>;

export const currencySchema = z.object({
  code: z.string().min(2),
  name: z.string(),
  symbol: z.string(),
});
export type Currency = z.infer<typeof currencySchema>;
